var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.417 28.9381C17.427 28.9381 20.6778 24.814 20.6778 19.7266C20.6778 14.6393 17.427 10.5151 13.417 10.5151C9.407 10.5151 6.15625 14.6393 6.15625 19.7266C6.15625 24.814 9.407 28.9381 13.417 28.9381Z",
    fill: "#FF955A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2883 21.1369C10.7078 21.1369 11.0478 20.7862 11.0478 20.3536C11.0478 19.921 10.7078 19.5703 10.2883 19.5703C9.86885 19.5703 9.52881 19.921 9.52881 20.3536C9.52881 20.7862 9.86885 21.1369 10.2883 21.1369Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.969 21.1369C16.3884 21.1369 16.7285 20.7862 16.7285 20.3536C16.7285 19.921 16.3884 19.5703 15.969 19.5703C15.5495 19.5703 15.2095 19.921 15.2095 20.3536C15.2095 20.7862 15.5495 21.1369 15.969 21.1369Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3252 16.2553C19.2266 13.9952 22.2784 10.0372 21.1416 7.41489C20.0047 4.79261 15.1098 4.49904 10.2083 6.75919C5.30689 9.01935 2.25508 12.9773 3.39192 15.5996C4.52875 18.2219 9.42374 18.5155 14.3252 16.2553Z",
    fill: "#FF955A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95459 24.3329C9.95459 24.3329 11.5343 26.2442 13.2052 24.1763",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4552 24.3329C16.4552 24.3329 14.8755 26.2442 13.2046 24.1763",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2046 26.5259V28.5938",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5726 17.4588H22.2891L23.4131 5.3335H25.4182L26.5726 17.4588Z",
    fill: "#FF955A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0859 18.5991H22.8049C22.3854 18.5991 22.0454 18.9498 22.0454 19.3824V21.0743C22.0454 21.5069 22.3854 21.8576 22.8049 21.8576H26.0859C26.5054 21.8576 26.8454 21.5069 26.8454 21.0743V19.3824C26.8454 18.9498 26.5054 18.5991 26.0859 18.5991Z",
    fill: "#FF955A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5419 25.7467C26.5419 27.6266 24.3242 29.1619 24.3242 29.1619C24.3242 29.1619 22.1672 27.6266 22.1065 25.7467C22.0457 22.5196 23.109 22.6762 24.3242 22.6762C25.5394 22.6762 26.5419 22.3316 26.5419 25.7467Z",
    fill: "#FF955A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconOrange);
export default __webpack_public_path__ + "static/media/profileIconOrange.c79f37217d3f95e4cf17f68124dc297b.svg";
export { ForwardRef as ReactComponent };